import instanciaAxios from './InterceptorAxios';

const servicioPaginacion = {

    paginacionGeneral(objetoPaginacion) {        
        return instanciaAxios.post("/paginacion/paginacion.json", objetoPaginacion);
    }
}

export default servicioPaginacion;